export function studioPlanTitle(effectiveDate: string) {
  return `${effectiveDate.replaceAll('-', '.')} 조직 발령안`;
}

/** 저장된 기본 제목만 시행일에 맞추고 사용자가 정한 이름은 보존합니다. */
export function withStudioEffectiveDate<T extends { title: string; effectiveDate: string }>(draft: T, effectiveDate: string): T {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(effectiveDate)) return draft;
  const date = new Date(`${effectiveDate}T00:00:00Z`);
  if (Number.isNaN(date.valueOf()) || date.toISOString().slice(0, 10) !== effectiveDate || effectiveDate === draft.effectiveDate) return draft;
  const automatic = ['조직 변경안', '조직 발령안', `${draft.effectiveDate.replaceAll('-', '.')} 조직 변경안`, studioPlanTitle(draft.effectiveDate)].includes(draft.title);
  return { ...draft, effectiveDate, title: automatic ? studioPlanTitle(effectiveDate) : draft.title };
}
